"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Integration = void 0;
var Integration;
(function (Integration) {
    Integration["ALARM_DOT_COM"] = "adc";
    Integration["ALEXA"] = "alexa";
    Integration["SMART_THINGS"] = "smartthings";
    Integration["SMART_THINGS_SCHEMA"] = "smartthings_schema";
    Integration["GOOGLE_ASSISTANT"] = "googlehome";
})(Integration = exports.Integration || (exports.Integration = {}));
//# sourceMappingURL=Integration.js.map